export const PROJECT_SETTINGS = {
  // ProjectSettings main component
  BACK_TO_PROJECT_BUTTON: 'project-settings-back-to-project-button',
  PROJECT_DETAILS_TAB: 'project-settings-project-details-tab',
  VERSION_DETAILS_TAB: 'project-settings-version-details-tab',
  DEFAULT_CALENDAR_TAB: 'project-settings-default-calendar-tab',
  RESOURCE_WORK_HOURS_TAB: 'project-settings-resource-work-hours-tab',
  GROUP_DURATION_TAB: 'project-settings-group-duration-tab',
  SCHEDULING_MODE_TAB: 'project-settings-scheduling-mode-tab',
  PPC_TAB: 'project-settings-ppc-tab',
  CANCEL_BUTTON: 'project-settings-cancel-button',
  SAVE_CHANGES_BUTTON: 'project-settings-save-changes-button',
  WORK_HOURS_INPUT: 'project-settings-work-hours-input',

  // Project Brief (CHAT-1677)
  MANNY_CONTEXT_BANNER: 'project-settings-manny-context-banner',
  PROJECT_BRIEF_PANEL: 'project-settings-project-brief-panel',
  PROJECT_LOCATION_INPUT: 'project-settings-project-location-input',
  PROJECT_DESCRIPTION_INPUT: 'project-settings-project-description-input',
  PROJECT_SCHEDULE_REQUIREMENTS_INPUT: 'project-settings-project-schedule-requirements-input',

  // EditProjectVersion elements
  VERSION_NAME_INPUT: 'project-settings-version-name-input',
  VERSION_DESCRIPTION_INPUT: 'project-settings-version-description-input',
  PROJECT_TAGS: 'project-settings-project-tags',

  // EditScheduleMode elements
  RETAINED_LOGIC_OPTION: 'project-settings-retained-logic-option',
  PROGRESS_OVERRIDE_OPTION: 'project-settings-progress-override-option',
  RETAINED_LOGIC_RADIO: 'project-settings-retained-logic-radio',
  PROGRESS_OVERRIDE_RADIO: 'project-settings-progress-override-radio',

  // EditGroupDurationCalendar elements
  CALENDAR_DAYS_OPTION: 'project-settings-calendar-days-option',
  PROJECT_DEFAULT_CALENDAR_OPTION: 'project-settings-project-default-calendar-option',

  // EditPPCEnabled elements
  PPC_SWITCH_BUTTON: 'project-settings-ppc-switch-button',

  // Discard Changes Dialog
  DISCARD_DIALOG: 'project-settings-discard-dialog',
  DISCARD_DIALOG_TITLE: 'project-settings-discard-dialog-title',
  DISCARD_DIALOG_KEEP_EDITING: 'project-settings-discard-dialog-keep-editing',
  DISCARD_DIALOG_DISCARD: 'project-settings-discard-dialog-discard'
} as const;
